import { render, staticRenderFns } from "./AnnotationRecordItemFeature.vue.js?vue&type=template&id=57af8df5&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordItemFeature.vue?vue&type=template&id=57af8df5&scoped=true"
import script from "./AnnotationRecordItemFeature.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordItemFeature.vue?vue&type=script&lang=js"
export * from "./AnnotationRecordItemFeature.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordItemFeature.vue?vue&type=script&lang=js"
import style0 from "./AnnotationRecordItemFeature.vue.scss?vue&type=style&index=0&id=57af8df5&prod&scoped=true&lang=scss!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordItemFeature.vue?vue&type=style&index=0&id=57af8df5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57af8df5",
  null
  
)

export default component.exports